<script setup lang="ts">
import type { D4HRosterMatch } from '@/types'

defineProps<{
  match: D4HRosterMatch
}>()
</script>

<template>
  <div class="bg-surface-container-high border border-border rounded p-4 flex gap-3 items-start">
    <span class="material-symbols-outlined text-primary text-[20px] mt-0.5 shrink-0">link</span>
    <div>
      <p class="text-on-surface font-semibold text-sm">
        Your D4H record is connected<template v-if="match.team_name"> ({{ match.team_name }})</template>
      </p>
      <p class="text-on-surface-variant text-xs mt-0.5">
        We've filled in your name, phone and qualifications from D4H. Check them before continuing.
      </p>
    </div>
  </div>
</template>
